export const ar = {
  pageTitle: "التقارير",
  dateRange: { from: "من", to: "إلى" },
  filters: {
    triggerTypeAriaLabel: "تصفية حسب نوع الزناد",
    allTriggers: "كل المحفزات",
  },
  export: {
    fileName: "تقرير-النشاط.csv",
    csvButton: "تصدير CSV",
    errorTitle: "فشل التصدير",
    errorDescription: "تعذر تنزيل تقرير CSV. حاول مرة أخرى.",
    columns: {
      activityId: "معرف النشاط",
      triggerType: "نوع المحفز",
      sourceReference: "مرجع المصدر",
      status: "الحالة",
      outcome: "النتيجة",
      priority: "الأولوية",
      value: "القيمة",
      currency: "العملة",
      assigneeEmail: "البريد الإلكتروني للمندوب",
      createdAt: "تاريخ الإنشاء",
    },
  },
  kpi: {
    activitiesCreated: "المهام المنشأة",
    completed: "مكتمل",
    completionRate: "معدل الإكمال",
    vsPrevPeriod: "مقارنة بالفترة السابقة",
  },
  volume: {
    title: "حجم المهام اليومي",
    loadingSubtitle: "جارٍ تحميل بيانات المهمة...",
    days: "أيام",
    empty: {
      title: "لا توجد بيانات نشاط",
      description: "حاول تعديل نطاق التاريخ لرؤية النتائج",
      subtitle: "لا توجد بيانات للفترة المحددة",
    },
    tooltip: {
      created: "تم الإنشاء",
      completed: "مكتمل",
      total: "الإجمالي",
      completionRate: "معدل الإكمال",
      vsPreviousDay: "مقارنة باليوم السابق",
    },
    stats: {
      total: "الإجمالي",
      totalTip: "إجمالي الأنشاط في الفترة",
      created: "تم الإنشاء",
      createdTip: "المهام المنشأة في الفترة",
      completed: "مكتمل",
      completedTip: "المهام المكتملة في الفترة",
      avgPerDay: "متوسط/يوم",
      avgPerDayTip: "متوسط إجمالي المهام يوميًا",
      rate: "المعدل",
      rateTip: "معدل الإكمال الإجمالي",
      peak: "الذروة",
      peakWithDate: "الذروة ({{date}})",
      peakTip: "أكثر أيام ازدحامًا في الفترة",
    },
    legend: { created: "تم الإنشاء ", completed: "مكتمل " },
    axis: { activities: "المهام" },
    refLine: { avgPerDay: "متوسط {{n}}/يوم" },
    bar: { created: "تم الإنشاء", completed: "مكتمل" },
  },
  repsTable: {
    title: "أفضل المندوبين",
    empty: "لا تتوفر بيانات المندوبين",
    col: { rep: "المندوب", completed: "مكتمل", assigned: "معيّن", rate: "المعدل" },
  },
  outcomes: {
    title: "توزيع النتائج",
    loadingSubtitle: "جارٍ تحميل بيانات النتائج...",
    group: { completed: "مكتمل", rejected: "مرفوض", warning: "تحذير", inProgress: "قيد التنفيذ", other: "أخرى" },
    collapsedMore: "أخرى ({{n}} أكثر)",
    sort: { byCount: "حسب العدد", byGroup: "حسب المجموعة" },
    pills: {
      total: "الإجمالي",
      totalTip: "إجمالي المهام المكتملة ذات النتائج",
      successRate: "معدل النجاح",
      successRateTip: "مؤكد + مسترد + محول / الإجمالي",
      top: "الأعلى",
      topTip: "النتيجة الأكثر شيوعًا ({{n}})",
      categories: "الفئات",
      categoriesTip: "أنواع النتائج المميزة في الفترة",
    },
    row: { topBadge: "الأعلى", collapsedBadge: "مطوي" },
    tooltip: {
      rank: "#{{rank}}",
      shareOfTotal: "{{pct}}% من إجمالي {{total}}",
      groupOutcome: "نتيجة {{group}}",
    },
    empty: {
      title: "لا توجد بيانات نتائج",
      description: "ستظهر المهام المكتملة هنا",
      subtitle: "لا توجد بيانات للفترة المحددة",
    },
    subtitle: { outcomes: "{{n}} نتائج", categories: "{{n}} فئات", acrossJoiner: " عبر " },
  },
  topReps: {
    title: "أداء أفضل المندوبين",
    loadingSubtitle: "جارٍ تحميل بيانات المندوبين...",
    metric: { completed: "مكتمل", rate: "المعدل" },
    tooltip: { rank: "#{{rank}}", completed: "مكتمل", assigned: "معيّن", rate: "المعدل" },
    teamAverage: "متوسط الفريق",
    completedWord: "مكتمل",
    rateWord: "معدل",
    totalWord: "إجمالي",
    empty: {
      title: "لا توجد بيانات مندوبين",
      description: "سيظهر المندوبون المعينون هنا",
      subtitle: "لا توجد بيانات للفترة المحددة",
    },
    subtitle: "{{repCount}} مندوبين · {{total}} إجمالي مكتمل",
  },
} as const;
